module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Pizza-d7dc89717ee53bf39e642b04a2968a95.svg";